import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";
import { Message } from "element-ui";


const definition = {
  state: () => ({
    userLanguages:[],
    enums: [],
    deleteReasons:[],
  }),
  actions: {
    async getEnums(store){
      var res = await axios.get('definition/listenums')
      if(!res.data.hasError){
        store.commit('setEnums',res.data.data.items);
      }
    },
   async getAccountDeleteReasons(store,payload){
    var res = await axios.post('definition/getaccountdeletionreasons', {skip:0,take:1000,searchTerm:null});
    if(!res.data.hasError){
      store.commit('setDeleteReasons',res.data.data.items);
    }
   },
    async getUserLanguages(store){
      var res = await axios.post('definition/searchuserlanguage', {skip:0,take:1000,searchTerm:null})
      if(!res.data.hasError){
        store.commit('setLanguageList', res.data.data.items);
      }
    },
    async getApplicationPolicies(store,payload){
      var res = await axios.post('/Definition/GetApplicationPolicies', {id : payload});
      if(res.data.hasError){
        Message.error(res.data.message);
      }
      return res;
    },
  },
  mutations: {
    setDeleteReasons(state,payload){
      state.deleteReasons = payload;
    },
    setEnums(state,payload){
      state.enums = payload;
    },
    setLanguageList(state,payload){
      state.userLanguages = payload;
    },
  },
  getters: {
    getAccountDeleteReasons: (state) => state.deleteReasons,
    getEnums: (state) => state.enums,
    getUserLanguages:(state) => state.userLanguages,
  }
}

export default definition;


// WEBPACK FOOTER //
// ./src/store/definition.js